const layout = () => import("../../internal/layout.vue");
const collect = () => import("./collect.vue");
const collectV2 = () => import("./collectV2.vue");

const collectRoutes = {
  component: layout,
  children: [
    {
      path: "/",
      name: "collect",
      meta: {
        title: "COLETA",
        requiresAuth: true,
      },
      component: collect,
    },
      {
      path: "v2",
      name: "collectV2",
      meta: {
        title: "COLETA",
        requiresAuth: true,
      },
      component: collectV2,
    },
  ],
};

export default collectRoutes;
